import Placeholder from '../components/Placeholder';

export default function About() {
  return (
    <Placeholder title="About Page" />
  );
}
